<main class="alerts-page">
  <header class="alerts-head">
    <div class="alerts-head__copy">
      <span class="eyebrow"><i class="ri-radar-line"></i> Centro operacional</span>
      <h1>Alertas</h1>
      <p>Acompanhe falhas de cobertura e ocorrências que exigem atenção.</p>
    </div>

    <div class="alerts-head__actions">
      <div
        class="connection-status"
        [class.is-connected]="connectionState === 'connected'"
      >
        <span class="connection-status__dot"></span>
        <span>
          <small>Canal em tempo real</small>
          <strong>{{ connectionLabel }}</strong>
        </span>
      </div>
      <button
        type="button"
        class="refresh-button"
        [disabled]="refreshing"
        (click)="refreshAll()"
      >
        <i class="ri-refresh-line" [class.is-spinning]="refreshing"></i>
        {{ refreshing ? "A atualizar" : "Atualizar" }}
      </button>
    </div>
  </header>

  <section class="alert-kpis" aria-label="Resumo dos alertas">
    <article class="alert-kpi alert-kpi--primary">
      <span class="alert-kpi__icon"><i class="ri-notification-3-line"></i></span>
      <div>
        <small>Alertas ativos</small>
        <strong>{{ totalActiveAlerts }}</strong>
        <p>Requerem acompanhamento</p>
      </div>
    </article>
    <article class="alert-kpi alert-kpi--danger">
      <span class="alert-kpi__icon"><i class="ri-map-pin-time-line"></i></span>
      <div>
        <small>Sem cobertura</small>
        <strong>{{ postosSemCobertura.length }}</strong>
        <p>Postos sem escala hoje</p>
      </div>
    </article>
    <article class="alert-kpi alert-kpi--warning">
      <span class="alert-kpi__icon"><i class="ri-alarm-warning-line"></i></span>
      <div>
        <small>Urgentes</small>
        <strong>{{ urgentCount }}</strong>
        <p>Ocorrências por tratar</p>
      </div>
    </article>
    <article class="alert-kpi alert-kpi--info">
      <span class="alert-kpi__icon"><i class="ri-mail-unread-line"></i></span>
      <div>
        <small>Por ler</small>
        <strong>{{ unreadCount }}</strong>
        <p>De {{ ocorrencias.length }} recebidas</p>
      </div>
    </article>
  </section>

  <section class="alerts-toolbar" aria-label="Filtros de alertas">
    <div class="section-switcher" role="tablist" aria-label="Tipo de alerta">
      <button
        type="button"
        [class.active]="activeSection === 'all'"
        (click)="setSection('all')"
      >
        <i class="ri-layout-grid-line"></i> Todos
        <span>{{ postosSemCobertura.length + ocorrencias.length }}</span>
      </button>
      <button
        type="button"
        [class.active]="activeSection === 'coverage'"
        (click)="setSection('coverage')"
      >
        <i class="ri-map-pin-line"></i> Cobertura
        <span>{{ postosSemCobertura.length }}</span>
      </button>
      <button
        type="button"
        [class.active]="activeSection === 'occurrences'"
        (click)="setSection('occurrences')"
      >
        <i class="ri-shield-flash-line"></i> Ocorrências
        <span>{{ ocorrencias.length }}</span>
      </button>
    </div>

    <label class="alerts-search">
      <i class="ri-search-line"></i>
      <input
        type="search"
        [value]="searchTerm"
        placeholder="Pesquisar posto, código, efetivo ou ocorrência..."
        (input)="onSearch($any($event.target).value)"
      />
      <button
        *ngIf="searchTerm"
        type="button"
        aria-label="Limpar pesquisa"
        (click)="clearSearch()"
      >
        <i class="ri-close-line"></i>
      </button>
    </label>
  </section>

  <div class="alerts-meta">
    <span
      ><i class="ri-time-line"></i> Atualizado às
      {{ lastUpdatedAt | date: "HH:mm" }}</span
    >
    <span>Os alertas não lidos contam como ativos.</span>
  </div>

  <section class="alerts-panel coverage-panel" *ngIf="showCoverage">
    <header class="panel-head">
      <div class="panel-head__identity">
        <span class="panel-head__icon panel-head__icon--danger"
          ><i class="ri-map-pin-time-line"></i
        ></span>
        <div>
          <span class="panel-kicker">Cobertura operacional</span>
          <h2>Postos sem escala hoje</h2>
          <p>Priorize estes postos para garantir a equipa necessária.</p>
        </div>
      </div>
      <span class="panel-count" [class.has-alerts]="filteredPostos.length > 0">
        {{ filteredPostos.length }}
        {{ filteredPostos.length === 1 ? "posto" : "postos" }}
      </span>
    </header>

    <div
      class="alert-list"
      *ngIf="pagedPostos.length > 0; else emptyCoverage"
    >
      <article
        class="coverage-card"
        *ngFor="let posto of pagedPostos; trackBy: trackPosto"
      >
        <span class="alert-visual alert-visual--danger"
          ><i class="ri-team-line"></i
        ></span>
        <div class="alert-card__body">
          <div class="alert-card__topline">
            <span class="alert-code">{{
              posto.codigo || "PST-" + posto.id
            }}</span>
            <span class="status-pill status-pill--danger"
              ><i class="ri-error-warning-line"></i> Sem cobertura</span
            >
          </div>
          <h3>{{ posto.nome }}</h3>
          <div class="alert-card__meta">
            <span
              ><i class="ri-building-2-line"></i>
              {{ posto.nomeCliente || "Cliente não informado" }}</span
            >
            <span
              ><i class="ri-map-pin-2-line"></i>
              {{ postoLocation(posto) }}</span
            >
            <span
              ><i class="ri-user-add-line"></i> Necessários:
              {{ posto.numEfetivosTurno || 0 }} / turno</span
            >
          </div>
        </div>
        <div class="alert-card__next-step">
          <small>Próxima ação</small>
          <a
            *ngIf="posto.id; else unavailablePostAction"
            [routerLink]="['/admin/postos', posto.id]"
            [queryParams]="{ tab: 'escala', acao: 'criar' }"
          >
            Completar escala <i class="ri-arrow-right-line"></i>
          </a>
          <ng-template #unavailablePostAction
            ><span>Posto indisponível</span></ng-template
          >
        </div>
      </article>
    </div>

    <ng-template #emptyCoverage>
      <app-empty-state
        appearance="orbit"
        [icon]="
          searchTerm ? 'ri-search-eye-line' : 'ri-shield-check-line'
        "
        [title]="
          searchTerm ? 'Nenhum posto encontrado' : 'Cobertura assegurada'
        "
        [message]="
          searchTerm
            ? 'A pesquisa não corresponde a nenhum posto sem cobertura.'
            : 'Todos os postos têm uma escala ativa para hoje.'
        "
      />
    </ng-template>

    <div
      class="panel-pagination"
      *ngIf="filteredPostos.length > coverageRows"
    >
      <app-paginator-control
        [first]="coverageFirst"
        [rows]="coverageRows"
        [totalRecords]="filteredPostos.length"
        [rowsPerPageOptions]="[5, 10, 20]"
        [alwaysShow]="false"
        [showCurrentPageReport]="true"
        (pageChange)="onCoveragePageChange($event)"
      />
    </div>
  </section>

  <section class="alerts-panel occurrences-panel" *ngIf="showOccurrences">
    <header class="panel-head panel-head--occurrences">
      <div class="panel-head__identity">
        <span class="panel-head__icon panel-head__icon--warning"
          ><i class="ri-shield-flash-line"></i
        ></span>
        <div>
          <span class="panel-kicker">Segurança em tempo real</span>
          <h2>Ocorrências recebidas</h2>
          <p>Consulte a criticidade e confirme os alertas já analisados.</p>
        </div>
      </div>
      <button
        type="button"
        class="mark-read-button"
        [disabled]="unreadCount === 0"
        (click)="marcarTodasComoLidas()"
      >
        <i class="ri-check-double-line"></i> Marcar todas como lidas
      </button>
    </header>

    <div
      class="occurrence-filters"
      role="group"
      aria-label="Estado das ocorrências"
    >
      <button
        type="button"
        [class.active]="occurrenceFilter === 'all'"
        (click)="setOccurrenceFilter('all')"
      >
        Todas <span>{{ ocorrencias.length }}</span>
      </button>
      <button
        type="button"
        [class.active]="occurrenceFilter === 'unread'"
        (click)="setOccurrenceFilter('unread')"
      >
        Por ler <span>{{ unreadCount }}</span>
      </button>
      <button
        type="button"
        [class.active]="occurrenceFilter === 'urgent'"
        (click)="setOccurrenceFilter('urgent')"
      >
        Urgentes <span>{{ urgentCount }}</span>
      </button>
    </div>

    <div
      class="alert-list"
      *ngIf="pagedOcorrencias.length > 0; else emptyOccurrences"
    >
      <article
        class="occurrence-card"
        *ngFor="
          let ocorrencia of pagedOcorrencias;
          trackBy: trackOccurrence
        "
        [class.is-unread]="!ocorrencia.lida"
        [class.is-urgent]="ocorrencia.criticidadeEnum === 3"
      >
        <span
          class="alert-visual"
          [ngClass]="
            'alert-visual--' + severityClass(ocorrencia.criticidadeEnum)
          "
        >
          <i [class]="occurrenceIcon(ocorrencia)"></i>
        </span>
        <div class="alert-card__body">
          <div class="alert-card__topline">
            <span class="alert-code">#OC-{{ ocorrencia.id }}</span>
            <span
              class="status-pill"
              [ngClass]="
                'status-pill--' + severityClass(ocorrencia.criticidadeEnum)
              "
            >
              {{
                notificationSvc.criticidadeLabel(ocorrencia.criticidadeEnum)
              }}
            </span>
            <span class="unread-pill" *ngIf="!ocorrencia.lida"
              ><i></i> Novo</span
            >
          </div>
          <h3>{{ notificationSvc.tipoLabel(ocorrencia) }}</h3>
          <div class="alert-card__meta">
            <span
              ><i class="ri-map-pin-2-line"></i>
              {{ ocorrencia.nomePosto || "Posto não identificado" }}</span
            >
            <span
              ><i class="ri-user-3-line"></i>
              {{ ocorrencia.nomeEfetivo || "Efetivo não identificado" }}</span
            >
            <time
              ><i class="ri-calendar-event-line"></i>
              {{
                ocorrencia.dataOcorrencia | date: "dd/MM/yyyy · HH:mm"
              }}</time
            >
          </div>
        </div>
        <div class="occurrence-actions">
          <button
            type="button"
            class="read-button"
            *ngIf="!ocorrencia.lida; else readState"
            (click)="marcarComoLida(ocorrencia.id)"
          >
            <i class="ri-check-line"></i> Marcar como lida
          </button>
          <ng-template #readState
            ><span class="read-state"
              ><i class="ri-check-double-line"></i> Lida</span
            ></ng-template
          >
          <a routerLink="/admin/posto-comando" aria-label="Abrir posto de comando">
            Analisar <i class="ri-arrow-right-line"></i>
          </a>
        </div>
      </article>
    </div>

    <ng-template #emptyOccurrences>
      <app-empty-state
        appearance="orbit"
        [icon]="
          searchTerm || occurrenceFilter !== 'all'
            ? 'ri-search-eye-line'
            : 'ri-notification-off-line'
        "
        [title]="
          searchTerm || occurrenceFilter !== 'all'
            ? 'Nenhuma ocorrência encontrada'
            : 'Sem ocorrências recebidas'
        "
        [message]="
          searchTerm || occurrenceFilter !== 'all'
            ? 'Ajuste a pesquisa ou selecione outro estado.'
            : 'As novas ocorrências aparecerão aqui através do canal em tempo real.'
        "
      />
    </ng-template>

    <div
      class="panel-pagination"
      *ngIf="filteredOcorrencias.length > occurrenceRows"
    >
      <app-paginator-control
        [first]="occurrenceFirst"
        [rows]="occurrenceRows"
        [totalRecords]="filteredOcorrencias.length"
        [rowsPerPageOptions]="[5, 10, 20]"
        [alwaysShow]="false"
        [showCurrentPageReport]="true"
        (pageChange)="onOccurrencePageChange($event)"
      />
    </div>
  </section>
</main>
